import React from "react";
// import GoogleMapComponent from "../../Components/Maps/GoogleMapComponent";

const LocationDetails = ({ event }) => {
  return (
    <>
      <p className="pageHeaders">Event Location</p>
      <hr className="mt-0" />

      <iframe
        width="600"
        height="450"
        style={{ maxWidth: "100%", height: "30vh" }}
        loading="lazy"
        allowfullscreen
        referrerpolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_API}
    &q=${event?.venue}&zoom=5`}
      ></iframe>
      {/* <GoogleMapComponent
        latitude={event?.latitude}
        longitude={event?.longitude}
        address={event?.venue}
        state={event?.state}
      /> */}
      <br></br>
      <div className="location-Details">
        <p className="m-0">Venue: {event?.venue_name}</p>
        <p className="m-0">City: {event?.venue_city}</p>
        <p className="m-0">Region: {event?.region}</p>
        <p className="m-0">Postal Code: {event?.postal_code}</p>
      </div>
    </>
  );
};

export default LocationDetails;
